import { FocusStyleManager } from "@blueprintjs/core";

export default () => FocusStyleManager.onlyShowFocusOnTabs();
